module.exports = __webpack_public_path__ + "images/e79925833e76500fe41adc14baa7404d-logo_white.png";